/* tslint:disable */
/* eslint-disable */
/**
 * Easy Invoices API v1
 * The Easy Invoices API for Shopify embedded app - automatic invoice generation and export functionality
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface UpdateSupportTicketCategoryDto
 */
export interface UpdateSupportTicketCategoryDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateSupportTicketCategoryDto
     */
    'category': UpdateSupportTicketCategoryDtoCategoryEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum UpdateSupportTicketCategoryDtoCategoryEnum {
    Question = 'QUESTION',
    Bug = 'BUG',
    FeatureRequest = 'FEATURE_REQUEST',
    Feedback = 'FEEDBACK',
    Billing = 'BILLING',
    TaxCompliance = 'TAX_COMPLIANCE',
    DataExport = 'DATA_EXPORT',
    Onboarding = 'ONBOARDING',
    Other = 'OTHER'
}


